import { useEffect, useState } from "react";
import useAxios from "../../../../Hooks/useAxios";
import useApp from "../../../../Hooks/useApp";

const initDoc = [];

function useTable() {
  const [limit, setLimit] = useState(10);
  const [docs, setDocs] = useState(initDoc);
  const [isLoading, setIsLoading] = useState(true);
  const [isFiltered, setIsFiltered] = useState(false);
  const request = useAxios();
  const { user } = useApp();

  // Pagination
  const [page, setPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPrevPage, setHasPrevPage] = useState(false);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(0);

  const [order, setOrder] = useState("id-desc");

  const refetchDocs = () => getDocs({ page: page, limit: limit });

  const [orderId, setOrderId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  useEffect(() => {
    getDocs({ page, limit });
  }, [page, limit, order]);

  async function getDocs({ page, limit }) {
    let res = await request({
      method: "GET",
      url: "purchase-orders/all",
      params: {
        page,
        limit,
        order,
      },
      show_loading: false,
      loadingFunc: setIsLoading,
    });

    // console.log("API response", res);

    if (res === "error") {
      return;
    }

    setTotal(res?.pagination?.total || 0);
    setPages(res?.pagination?.pages || 0);
    setHasNextPage(res?.pagination?.hasNextPage || false);
    setHasPrevPage(res?.pagination?.hasPrevPage || false);
    setDocs(res?.docs || initDoc);
  }

  async function clearFilters() {
    setIsFiltered(false);
  }

  function handleNext() {
    if (hasNextPage) {
      setPage((prevPage) => prevPage + 1);
    }
  }

  function handlePrev() {
    if (hasPrevPage) {
      setPage((prevPage) => prevPage - 1);
    }
  }

  async function handleDelete() {
    let res = await request({
      method: "DELETE",
      url: "purchase-orders/delete",
      params: {
        id: parseInt(orderId),
      },
    });

    if (res !== "error") {
      setShowDeleteModal(false);
      refetchDocs();
    }
  }

  async function handleApprove() {
    let res = await request({
      method: "PUT",
      url: "purchase-orders/approve",
      body: {
        id: parseInt(orderId),
        status: "approved",
        approved_by: parseInt(user?.id),
      },
    });

    if (res !== "error") {
      setShowApproveModal(false);
      refetchDocs();
    }
  }
  async function handleCancel() {
    let res = await request({
      method: "PUT",
      url: "purchase-orders/cancel",
      body: {
        id: parseInt(orderId),
        status: "cancelled",
      },
    });

    if (res !== "error") {
      setShowCancelModal(false);
      refetchDocs();
    }
  }

  return {
    limit,
    setLimit,
    docs,
    setDocs,
    isLoading,
    setIsLoading,
    isFiltered,
    setIsFiltered,
    pagination: {
      page,
      total,
      pages,
      hasNextPage,
      hasPrevPage,
      handleNext,
      handlePrev,
      limit,
      setLimit,
      total_docs: docs.length || 0,
    },
    setOrder,
    clearFilters,
    refetchDocs,
    orderId,
    setOrderId,
    showApproveModal,
    setShowApproveModal,
    showCancelModal,
    setShowCancelModal,
    showDeleteModal,
    setShowDeleteModal,
    handleDelete,
    handleApprove,
    handleCancel,
  };
}

export default useTable;
